<template>
  <Card>
    <CardHeader>
      <CardTitle>Credentials</CardTitle>
    </CardHeader>
    <CardContent>
      <p class="text-sm text-muted-foreground">
        Credentials related to this business system will appear here.
      </p>
    </CardContent>
  </Card>
</template>

<script setup>
import { Card, CardContent, CardHeader, CardTitle } from '../../../../../../../../resources/js/components/ui/card/index.js'
</script>
